import { useState } from "react";
import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import DocumentRow from "./DocumentRow";
import DeleteAgreementModal from "../Agreements/DeleteAgreementModal";

const ViewAllDocumentsModal = ({ person, onClose, handleDocumentDelete, documents, show }) => {
  const [saveDocId, setSaveDocId] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const onClickDeleteDoc = (docId) => {
    setOpenDeleteModal(true);
    setSaveDocId(docId);
  };

  const deleteCloseModal = () => {
    setOpenDeleteModal(false);
  };

  const deleteDoc = () => {
    handleDocumentDelete(person.data.attributes, saveDocId);
    deleteCloseModal();
  };

  return (
    <>
      <Modal
        id="view-all-documents-modal"
        show={show}
        onHide={onClose}
        dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
        contentClassName="tw-max-w-[800px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
      >
        <Modal.Header title="Documents" closeButton />

        <Modal.Body className="tw-flex-1 tw-overflow-auto">
          <div className="tw-flex tw-gap-[8px]">
            <div className="tw-basis-4/12">
              <h6>NAME</h6>
            </div>
            <div className="tw-basis-1/12">
              <h6>TYPE</h6>
            </div>
            <div className="tw-basis-1/12">
              <h6>SIZE</h6>
            </div>
            <div className="tw-basis-2/12">
              <h6>DATE ADDED</h6>
            </div>
            <div className="tw-basis-3/12">
              <h6>UPLOADED BY</h6>
            </div>
            <div className="tw-basis-1/12">
              <h6>ACTIONS</h6>
            </div>
          </div>
          <div id="person-document-uploads">
            {documents.map((document) => (
              <DocumentRow key={document.id} document={document} onDelete={onClickDeleteDoc} />
            ))}
          </div>
        </Modal.Body>

        <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
          <Button size="medium" schema="tertiary" onClick={onClose}>
            Cancel
          </Button>
          <Button size="medium" onClick={onClose}>
            Done
          </Button>
        </Modal.Footer>
      </Modal>

      {openDeleteModal && (
        <DeleteAgreementModal
          modalOpen={openDeleteModal}
          onDelete={deleteDoc}
          closeModal={deleteCloseModal}
          title="Delete Document?"
          msg="Deleting this document will remove it from both the agreement and the Documents section."
        />
      )}
    </>
  );
};

ViewAllDocumentsModal.propTypes = {
  person: PropTypes.shape({
    data: PropTypes.shape({ attributes: PropTypes.shape().isRequired }).isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  handleDocumentDelete: PropTypes.func.isRequired,
  documents: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  show: PropTypes.bool.isRequired,
};

export default ViewAllDocumentsModal;
